(function () {
  'use strict';
  const DAY = 86400000;
  function parseDate(value) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return null;
    const date = new Date(value + 'T00:00:00Z');
    return Number.isFinite(+date) && date.toISOString().slice(0, 10) === value ? date : null;
  }
  function compute(deadline, size, unit, today) {
    const end = parseDate(deadline), start = parseDate(today);
    const factors = { ft: 12, in: 1, cm: 1 / 2.54 };
    size = Number(size);
    if (!end || !start || !Number.isFinite(size) || size <= 0 || !factors[unit]) return { error: 'invalid' };
    if (end < start) return { error: 'past' };
    const lead = size * factors[unit] >= 72 - 1e-8 ? 28 : 24;
    const recommendedLead = lead + 2;
    const lastDay = new Date(+end - lead * DAY).toISOString().slice(0, 10);
    const orderBy = new Date(+end - recommendedLead * DAY).toISOString().slice(0, 10);
    const days = Math.round((+parseDate(orderBy) - start) / DAY);
    const lastDays = Math.round((+parseDate(lastDay) - start) / DAY);
    const feasible = lastDays >= 0;
    const status = !feasible ? 'no' : days < 0 ? 'tight' : 'yes';
    return { lead, recommendedLead, orderBy, lastDay, days, lastDays, feasible, status, deadline, size, unit };
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { compute, parseDate };
  if (typeof document === 'undefined') return;
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const form = root.querySelector('[data-event-form]');
    const result = root.querySelector('[data-event-result]');
    const error = root.querySelector('[data-event-error]');
    const messages = JSON.parse(root.querySelector('[data-event-messages]').textContent);
    function today() {
      const parts = new Intl.DateTimeFormat('en-US', { timeZone: 'America/Los_Angeles', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date());
      const values = Object.fromEntries(parts.map(part => [part.type, part.value]));
      return values.year + '-' + values.month + '-' + values.day;
    }
    function displayDate(value) {
      return new Intl.DateTimeFormat('en-US', { month: 'long', day: 'numeric', year: 'numeric', timeZone: 'UTC' }).format(parseDate(value));
    }
    form.elements.deadline.min = today();
    function reset() {
      root.querySelector('[data-event-answer]').hidden = true;
      root.querySelector('[data-event-empty]').hidden = false;
      error.hidden = true;
      delete result.dataset.feasible;
    }
    form.addEventListener('input', reset);
    form.addEventListener('change', reset);
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      const plan = compute(form.elements.deadline.value, form.elements.size.value, form.elements.unit.value, today());
      if (plan.error) {
        reset();
        error.textContent = messages[plan.error];
        error.hidden = false;
        return;
      }
      error.hidden = true;
      root.querySelector('[data-event-empty]').hidden = true;
      root.querySelector('[data-event-answer]').hidden = false;
      result.dataset.feasible = plan.status === 'tight' ? 'tight' : String(plan.feasible);
      root.querySelector('[data-event-verdict]').textContent = messages[plan.status];
      root.querySelector('[data-event-order-date]').textContent = displayDate(plan.orderBy);
      root.querySelector('[data-event-last-date]').textContent = displayDate(plan.lastDay);
      const countdown = !plan.feasible ? 'no_detail' : plan.lastDays === 0 ? 'last_today' : plan.days < 0 ? 'tight_detail' : plan.days === 0 ? 'today' : plan.days === 1 ? 'one' : 'remaining';
      root.querySelector('[data-event-countdown]').textContent = messages[countdown].replace('{days}', plan.days);
      if (window.matchMedia('(max-width:767px)').matches) result.scrollIntoView({ block: 'start', behavior: window.matchMedia('(prefers-reduced-motion:reduce)').matches ? 'instant' : 'smooth' });
    });
  }
  document.querySelectorAll('[data-events-page]').forEach(init);
  document.addEventListener('shopify:section:load', function (event) { event.target.querySelectorAll('[data-events-page]').forEach(init); });
})();
